export default [
  {
    color: '#00F082',
    label: 'Electric green',
  },
  {
    color: '#80E28B',
    label: 'Spring green',
  },
  {
    color: '#69d7c4',
    label: 'Vivid teal',
  },
  {
    color: '#00F4FF',
    label: 'Aqua',
  },
  {
    color: '#52caef',
    label: 'Soft cyan',
  },
  {
    color: '#5c78ff',
    label: 'Neon blue',
  },
  {
    color: '#123bff',
    label: 'Vivid blue',
  },
  {
    color: '#8B9FFF',
    label: 'Light slate blue',
  },
  {
    color: '#7400b2',
    label: 'Strong violet',
  },
  {
    color: '#BA11EE',
    label: 'Neon purple',
  },
  {
    color: '#F50AC3',
    label: 'Deep pink',
  },
  {
    color: '#EC5ED6',
    label: 'Magenta',
  },
  {
    color: '#FF42A2',
    label: 'Wild strawberry',
  },
  {
    color: '#FF0015',
    label: 'Cadmiun red',
  },
  {
    color: '#E31C53',
    label: 'Kardinal red',
  },
  {
    color: '#FF4243',
    label: 'Tomato red',
  },
  {
    color: '#FF811C',
    label: 'Orange pumpkin',
  },
  {
    color: '#F06D0F',
    label: 'Flame',
  },
  {
    color: '#FFB229',
    label: 'Supernova',
  },
  {
    color: '#EAD215',
    label: 'Citrine',
  },
  {
    color: '#000E28',
    label: 'Black',
  },
  {
    color: '#ABADB0',
    label: 'Gray',
  },
]
